export default "__VITE_ASSET__36a5868f__"